"use client";

import { useState, useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
export default function BrandsPartners() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const partners = [{
    id: 1,
    name: "Grohe",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Grohe-Logo_300px.png"
  }, {
    id: 2,
    name: "Ceramica",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Ceramica-ribesalbes-Logo_300px.png"
  }, {
    id: 3,
    name: "Grupo",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Grupo-Halcon-Logo_300px.png"
  }, {
    id: 4,
    name: "Huida",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Huida-Logo_300px.png"
  }, {
    id: 5,
    name: "Jacob",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Jacob-Delafon-Paris-Logo_300px.png"
  }, {
    id: 6,
    name: "Keope",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Keope-Ceramiche-Logo_300px-1.jpg"
  }, {
    id: 7,
    name: "Mijares",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Mijares-Cerlat-Logo_300px.jpg"
  }, {
    id: 8,
    name: "Pavigres",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Pavigres-Grupo-Logo_300px.jpg"
  }, {
    id: 9,
    name: "Restone",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Restone2-Logo_300px.jpg"
  }, {
    id: 10,
    name: "Sanitana",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Sanitana-Logo.png"
  }, {
    id: 11,
    name: "STN",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/STN-Ceramica-Logo_300px.jpg"
  }, {
    id: 12,
    name: "Supergres",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Supergres-ceramiche-Logo_300px.jpg"
  }, {
    id: 13,
    name: "Venux",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Venux-Logo_300px.jpg"
  }, {
    id: 14,
    name: "Pamesa",
    logo: "https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/03/Pamesa-ceramica_300px.jpg"
  }];
  const itemsPerSlide = 4;
  const itemsPerSlideMobile = 2;
  const totalSlides = Math.ceil(partners.length / itemsPerSlide);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [dragOffset, setDragOffset] = useState(0);
  const sliderRef = useRef<HTMLDivElement>(null);
  const handlePrev = () => {
    setCurrentSlide(prev => prev === 0 ? totalSlides - 1 : prev - 1);
  };
  const handleNext = () => {
    setCurrentSlide(prev => prev === totalSlides - 1 ? 0 : prev + 1);
  };
  const handleDragStart = (clientX: number) => {
    setIsDragging(true);
    setStartX(clientX);
    setDragOffset(0);
  };
  const handleDragMove = (clientX: number) => {
    if (!isDragging) return;
    const diff = clientX - startX;
    setDragOffset(diff);
  };
  const handleDragEnd = () => {
    if (!isDragging) return;
    setIsDragging(false);
    const threshold = 50;
    if (dragOffset > threshold) {
      handlePrev();
    } else if (dragOffset < -threshold) {
      handleNext();
    }
    setDragOffset(0);
  };
  const handleMouseDown = (e: React.MouseEvent) => {
    handleDragStart(e.clientX);
  };
  const handleMouseMove = (e: React.MouseEvent) => {
    handleDragMove(e.clientX);
  };
  const handleMouseUp = () => {
    handleDragEnd();
  };
  const handleMouseLeave = () => {
    if (isDragging) {
      handleDragEnd();
    }
  };
  const handleTouchStart = (e: React.TouchEvent) => {
    handleDragStart(e.touches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    handleDragMove(e.touches[0].clientX);
  };
  const handleTouchEnd = () => {
    handleDragEnd();
  };
  const getVisibleBrands = () => {
    const start = currentSlide * itemsPerSlide;
    const end = start + itemsPerSlide;
    return partners.slice(start, end);
  };
  return <section id="brandspartners" className="py-16 md:py-24 bg-light-background text-foreground-light overflow-hidden">
    <div className="container mx-auto px-4 md:px-6">
      <div ref={headerRef} className={`text-center mb-12 md:mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <p className="font-display tracking-wide mb-2 !font-sans !font-normal !text-sm !text-[hsl(32,29%,42%)] md:mb-3">PREMIUM BRANDS WE TRUST</p>
        <h2 className="font-display font-semibold tracking-wide mb-4 !text-5xl">Brands & Partners</h2>
        <p className="leading-relaxed text-foreground-light max-w-3xl mx-auto mt-6 text-base md:text-lg">We work exclusively with internationally recognised brands in tiles and sanitary ware, ensuring durability, performance, and design excellence.</p>
      </div>

      {/* Increased max-width to accommodate 5 large logos comfortably */}
      <div className="relative max-w-7xl mx-auto">
        <div ref={sliderRef} className="overflow-hidden cursor-grab active:cursor-grabbing select-none" onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseLeave} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd}>
          <div className="flex transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
            transform: `translateX(calc(-${currentSlide * 100}% + ${dragOffset}px))`
          }}>
            {Array.from({
              length: totalSlides
            }).map((_, slideIndex) => <div key={slideIndex} data-index={slideIndex} className="flex-shrink-0 w-full flex gap-4 md:gap-6">
                {partners.slice(slideIndex * itemsPerSlide, (slideIndex + 1) * itemsPerSlide).map((partner, i) => <div key={partner.id} data-index={i}
              // Modified: aspect-square for 300x300 feel, basis-1/5 for 5 columns
              className="basis-1/2 md:basis-1/5 aspect-square flex items-center justify-center p-6 md:p-10 bg-primary/30 border border-border rounded-lg hover:bg-primary hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] pointer-events-none">
                    <img src={partner.logo} alt={partner.name}
                // Modified: increased height/width to take advantage of the 300px box
                className="max-h-full max-w-full w-auto h-auto object-contain" />
                  </div>)}
              </div>)}
          </div>
        </div>

        {/* Navigation Buttons */}
        <Button onClick={handlePrev} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 text-white rounded-full p-3 z-10 !bg-[hsl(32,29%,42%)] md:-translate-x-12 hover:opacity-90 transition-opacity" aria-label="Previous brands">
          <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" />
        </Button>

        <Button onClick={handleNext} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 text-white rounded-full p-3 z-10 !bg-[hsl(32,29%,42%)] md:translate-x-12 hover:opacity-90 transition-opacity" aria-label="Next brands">
          <ChevronRight className="w-5 h-5 md:w-6 md:h-6" />
        </Button>

        {/* Indicators */}
        <div className="flex justify-center gap-2 mt-12">
          {Array.from({
            length: totalSlides
          }).map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${currentSlide === index ? "bg-[hsl(32,29%,42%)] w-8" : "bg-gray-300"}`} aria-label={`Go to slide ${index + 1}`} />)}
        </div>
      </div>
    </div>
  </section>;
}